module.exports = __webpack_public_path__ + "img/audio.3e4b6598.png";